module.exports = __webpack_public_path__ + "img/mart2.83b109cb.jpeg";